import React, { useRef, useState } from 'react';

type ImgFallbackProps = {
  alt?: string;
  fallbackNode?: React.ReactNode;
  fallbackSrc?: string;
  onError?: () => void;
  src: string;
} & Record<string, any>

export const ImgFallback = ({
  alt,
  fallbackNode,
  fallbackSrc,
  onError = () => {},
  src,
  ...props
}: ImgFallbackProps) => {
  const [imgSrc, setImgSrc] = useState<string|undefined>(src);
  const errorHandled = useRef(false);

  const handleError = () => {
    if (!errorHandled.current) { // Prevents looping if fallback image fails
      errorHandled.current = true
      setImgSrc(fallbackSrc)
      onError()
    }
  };

  return (
    <>
      {!!imgSrc && (
        <img
          src={imgSrc}
          alt={alt}
          onError={handleError}
          {...props}
        />
      )}
      {!imgSrc && fallbackNode}
    </>
  );
};
